import { useDisclosure, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BookingDataService from "../../services/Booking";
import { SingleSIFFList } from "../../components/List/SingleSIFFList";
export const SiffList = () => {
    const navigate = useNavigate();
    const [list, setList] = useState<any>();
    const toast = useToast();
  
    const fetchData = async () => {
        BookingDataService.getSIFFData()
        .then((res: any) => {
          setList(res.data);
        })
        .catch((error: any) => {
          if (error.response.status === 401) {
            toast({
              position: "top",
              title: "Authentication Failed.",
              description: "Your session is expired.",
              status: "error",
              duration: 500,
              isClosable: true,
            });
            setTimeout(() => {
              navigate("/login");
            }, 2000);
          }
          console.log(error);
        });
    };
    useEffect(() => {
      fetchData();
    }, []);
    return (
      <>
        <div className="main-wrapper">
          <div className="page_title py-2">SIFF</div>
          <div className="p-4">
            <p className="center-icon">
              (Booking from backend are not visible)
            </p>

            {/* </div> */}

            {/* Main secttion */}
            <div className="main-section">
              <table className="table">
                <thead>
                  <tr>
                    {/* <th>Edit</th> */}
                    <th>Client Email</th>
                    <th>No. of bookings</th>
                    <th>Total Booking Payments</th>
                    {/* <th>Action</th> */}
                  </tr>
                </thead>
                <tbody>
                  {list && list.length > 0 ? (
                    list.map((el: any) => (
                      <SingleSIFFList
                        //   key={el.id}
                        {...el}
                      />
                    ))
                  ) : (
                    <h1 className="no-data">No Data Found</h1>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </>
    );
  };

